import TrainingPreviewModule from "../components/training-preview-module/training-preview-module";

export default function Training() {
  const urlPrefix: string = "#";
  return (
    <div className="ae-training-page -fade-in">
      <h1>Our training</h1>
      <TrainingPreviewModule fromPage={true} urlPrefix={urlPrefix} />
    </div>
  );
}
